import { Service } from '../mainService'

const cargoService = {
    getCargo,
    getHistoricoCargo,
    getTabelasAuxiliares,
    getListaCbo,
    listarCargos,
    salvarCargo,
    alterarCargo,
    corrigirDadosCargo,
    importarXml,
    baixarRelatorioDeInconsistencias,
    deletarCargo,
    verificarNormativo,
    verificarNomenclatura,
    buscarRegimesJuridicos
}

async function getCargo(idCargo) {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_PESSOAL_API + "/cargo/buscar/"+idCargo);
        return response;
    }
    catch(e) {
        return e.response;
    }
}

async function getHistoricoCargo(idCargo) {
    try {

        const response = await Service.$http.get(process.env.VUE_APP_PESSOAL_API + "/cargo/historico/"+idCargo);
        return response;
    }
    catch(e) {
        return e.response;
    }
}

async function getTabelasAuxiliares() {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_PESSOAL_API + "/cargo/tabelasauxiliares");
        return response;
    }
    catch(e) {
        return e.response;
    }
}

async function getListaCbo() {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_PESSOAL_API + "/cargo/listacbo");
        return response;
    }
    catch(e) {
        return e.response;
    }
}

async function listarCargos() {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_PESSOAL_API + "/cargo/listar");
        return response;
    }
    catch(e) {
        return e.response;
    }
}

async function salvarCargo(novoCargo) {
    try {
        const data = novoCargo;
        const response = await Service.$http.post(process.env.VUE_APP_PESSOAL_API + "/cargo/adicionar", data);
        return response;
    }
    catch(e) {
        return e.response;
    }
}

async function alterarCargo(novoCargo) {
    try {
        const data = novoCargo;
        const response = await Service.$http.post(process.env.VUE_APP_PESSOAL_API + "/cargo/alterar", data);
        return response;
    }
    catch(e) {
        return e.response;
    }
}

async function corrigirDadosCargo(novoCargo) {
    try {
        const data = novoCargo;
        const response = await Service.$http.post(process.env.VUE_APP_PESSOAL_API + "/cargo/corrigirdados", data);
        return response;
    }
    catch(e) {
        return e.response;
    }
}

async function importarXml(arquivo) {
    try {
        var data = new FormData();
        data.append("zipFile", arquivo);
        const response = await Service.$http.post(process.env.VUE_APP_PESSOAL_API + "/cargo/importar/xml", data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
        return response;
    } catch (e) {
        return e.response;
    }
}

async function baixarRelatorioDeInconsistencias(data) {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_PESSOAL_API + "/cargo/relatoriodeinconsistencias", data, { responseType: "blob"});
        return response;
    } catch (e) {
        return e.response;
    }
}

async function deletarCargo(idCargo) {
    try {

        const response = await Service.$http.delete(process.env.VUE_APP_PESSOAL_API + "/cargo/deletar/"+idCargo);
        return response;
    }
    catch(e) {
        return e.response;
    }
}

async function verificarNormativo(numeroNormativo, anoNormativo, tipoNormativo) {
    try {

        const response = await Service.$http.get(process.env.VUE_APP_PESSOAL_API + `/cargo/verificarnormativo/${numeroNormativo}/${anoNormativo}/${tipoNormativo}`);
        return response;
    }
    catch(e) {
        return e.response;
    }
}

async function verificarNomenclatura(nomenclatura) {
    try {

        const response = await Service.$http.get(process.env.VUE_APP_PESSOAL_API + `/cargo/verificarnomenclatura/${nomenclatura}`);
        return response;
    }
    catch(e) {
        return e.response;
    }
}

async function buscarRegimesJuridicos(idVinculo) {
    try {

        const response = await Service.$http.get(process.env.VUE_APP_PESSOAL_API + `/cargo/buscarregimesjuridicos/${idVinculo}`);
        return response;
    }
    catch(e) {
        return e.response;
    }
}

export default cargoService;